'use client';

import { c as _c } from "react/compiler-runtime";
import { type Dispatch, type SetStateAction, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import type { BasicMentoringProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { ORDER_TYPE } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/types';
import { SUBSCRIPTION, type Subscription } from '@/common/enums';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph/P3';
import { Button } from '@/frontend/design-system/actions/Button';
import { Divider } from '@/frontend/design-system/layouts/Divider';
import { VerticalSpacer } from '@/frontend/design-system/layouts/VerticalSpacer';
import { MentoringCard } from '../../_components/MentoringCard';
import { SubscriptionTabs } from '../../_components/SubscriptionTabs';
import { BuyData } from '../../BuyData';
import { calculateBasicMentoringPrice } from '../../prices';
import { ScheduleAppointmentDialog } from '../../ScheduleAppointmentDialog';
import { useUpdateMentoringProductOnTabChange } from '../AdvancedMentoringManager/_hooks/updateMentoringProductOnTabChange';
import { BasicMentoringOptions } from './Options';
export type { Subscription } from '@/common/enums';
type BasicMentoringProps = {
  activeSubscriptionTab: Subscription;
  setActiveSubscriptionTab: Dispatch<SetStateAction<Subscription>>;
};
export function BasicMentoring(t0) {
  const $ = _c(28);
  const {
    activeSubscriptionTab,
    setActiveSubscriptionTab
  } = t0;
  const [isScheduleAppointmentDialogOpen, setIsScheduleAppointmentDialogOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = calculateBasicMentoringPrice();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== activeSubscriptionTab) {
    t2 = {
      order: ORDER_TYPE.BASIC_MENTORING,
      price: t1,
      subscription: activeSubscriptionTab,
      email: "",
      name: "Mentoring podstawowy",
      quantity: 1
    };
    $[1] = activeSubscriptionTab;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [basicMentoringProduct, setBasicMentoringProduct] = useState(t2);
  let t3;
  if ($[3] !== activeSubscriptionTab || $[4] !== basicMentoringProduct) {
    t3 = {
      mentoringProduct: basicMentoringProduct,
      subscription: activeSubscriptionTab,
      setMentoringProduct: setBasicMentoringProduct
    };
    $[3] = activeSubscriptionTab;
    $[4] = basicMentoringProduct;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useUpdateMentoringProductOnTabChange(t3);
  const isMobile = useMediaQuery("(max-width: 1023px)");
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <P3>Odpowiada on uniwersalnym potrzebom uczniów. Idealny dla tych, którzy rozpoczynają przygodę z mentoringiem.</P3>;
    t5 = <VerticalSpacer size="paragraph" />;
    t6 = <P3>W ramach mentoringu otrzymujesz:</P3>;
    t7 = <VerticalSpacer size="paragraph" />;
    t8 = <BasicMentoringOptions />;
    t9 = <Divider className="my-4" />;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== activeSubscriptionTab || $[13] !== isMobile || $[14] !== setActiveSubscriptionTab) {
    t10 = isMobile && <div className="flex flex-col items-center"><P3 className="text-slate-900">Typ subskrypcji</P3><div className="h-3 w-full" /><SubscriptionTabs tabs={Object.values(SUBSCRIPTION)} activeTab={activeSubscriptionTab} setActiveTab={setActiveSubscriptionTab} /></div>;
    $[12] = activeSubscriptionTab;
    $[13] = isMobile;
    $[14] = setActiveSubscriptionTab;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== basicMentoringProduct) {
    t11 = <BuyData mentoringProduct={basicMentoringProduct} />;
    $[16] = basicMentoringProduct;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <VerticalSpacer size="content" />;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex flex-col items-center gap-3"><Button size="xl" className="w-full lg:w-fit" onClick={() => setIsScheduleAppointmentDialogOpen(true)}>Umów bezpłatne spotkanie</Button><Button plain={true} size="xl" href="/regulamin" className="w-full lg:w-fit">Szczegóły subskrypcji</Button></div>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setIsScheduleAppointmentDialogOpen(false);
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== basicMentoringProduct || $[22] !== isScheduleAppointmentDialogOpen) {
    t15 = <ScheduleAppointmentDialog mentoringProduct={basicMentoringProduct} isOpen={isScheduleAppointmentDialogOpen} onClose={t14} />;
    $[21] = basicMentoringProduct;
    $[22] = isScheduleAppointmentDialogOpen;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t15) {
    t16 = <MentoringCard title="Mentoring podstawowy">{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t15}</MentoringCard>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  return t16;
}